export const CustomBulletListExtensionName = 'customBulletList';

export const CustomListItemExtensionName = 'customListItem';

export const CustomOrderedListExtensionName = 'customOrderedList';
